var React = require('react');

function FlagSwitzerland (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},[React.createElement("path",{"d":"M0.5 0H22.5V15H0.5V0Z","fill":"#DA291C","key":0}),React.createElement("path",{"d":"M9.9277 2.8125H12.7402V6.09444H16.0221V8.90694H12.7402V12.1889H9.9277V8.90694H6.64575V6.09444H9.9277V2.8125Z","fill":"white","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"22","height":"15","fill":"white","transform":"translate(0.5)"})))]);
}

FlagSwitzerland.defaultProps = {"width":"23","height":"15","viewBox":"0 0 23 15","fill":"none"};

module.exports = FlagSwitzerland;

FlagSwitzerland.default = FlagSwitzerland;
